'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.composeAnalytics = composeAnalytics;
exports.composeEvent = composeEvent;
exports.composeLinkEvent = composeLinkEvent;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _utilsAnalytics = require('@bibliocommons/utils-analytics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACTIONS = _constantsAnalytics2.default.ACTIONS;
function composeAnalytics(events) {
  return {
    events: events
  };
}

function composeEvent(name, payload) {
  return {
    event: name,
    payload: payload
  };
}

function composeLinkEvent(name, url, payload) {
  var updatedPayload = _extends({}, payload);
  var isBiblio = (0, _utilsAnalytics.isBiblioLink)(url);

  return composeEvent(name, _extends({}, updatedPayload, {
    gtmAction: isBiblio ? ACTIONS.CLICK_LINK : ACTIONS.OUTBOUND_LINK_CLICK,
    gtmLabel: isBiblio ? payload.gtmLabel : url
  }));
}

exports.default = {
  composeAnalytics: composeAnalytics,
  composeEvent: composeEvent,
  composeLinkEvent: composeLinkEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/compose.js
// module id = 13
// module chunks = 0 2 4 5 6 8 9 10 11